import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-help-modal',
    templateUrl: './help-modal.component.html',
    styleUrls: ['./help-modal.component.scss'],
    standalone: false
})
export class HelpModalComponent implements OnInit {
  /*
    THIS IS JUST FOR THE DEMO
    I KNOW THIS IS UGLY 😢
  */

  helpDictionary = [
    {
      id: 'safjasdj2394234jdf93',
      title: 'Data to Suggest',
      body: `<p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quam facere ab ipsam natus maiores repudiandae
itaque laborum vero voluptatum quasi quod, vitae consequuntur mollitia harum nam voluptatem ad dicta earum!</p><p>Lorem
ipsum dolor sit amet consectetur, adipisicing elit. Ratione quis in ut ipsum vel? Itaque commodi repellendus neque sint
cumque.</p><ul><li>Lorem ipsum dolor sit amet.</li><li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni
dignissimos cumque enim?</li></ul>`,
    },
    {
      id: '2j34j2jd9fadsjf2',
      title: 'Diagnosis of a Condition',
      body: `<p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quam facere ab ipsam natus maiores repudiandae
itaque laborum vero voluptatum quasi quod, vitae consequuntur mollitia harum nam voluptatem ad dicta earum!</p><ul>
<li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni dignissimos cumque enim?</li></ul>`,
    },
    {
      id: '234jksdf903',
      title: 'Discernible Effect',
      body: `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam molestias iste vitae!</p><p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio voluptas dolor eum sapiente corporis, quibusdam,
provident repudiandae nisi unde quidem molestiae iusto.</p><ul><li>Lorem ipsum dolor sit amet consectetur adipisicing elit.
Magni dignissimos cumque enim?</li></ul>`,
    },
    {
      id: 'ksadjflsd9823423',
      title: 'Unique',
      body: `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam molestias iste vitae!</p><p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio voluptas dolor eum sapiente corporis, quibusdam,
provident repudiandae nisi unde quidem molestiae iusto.</p><ul><li>Lorem ipsum dolor sit amet consectetur adipisicing elit.
Magni dignissimos cumque enim?</li></ul>`,
    },
    {
      id: 'asdfsdklj234293823',
      title: 'Provision of Special Education and Related Services',
      body: `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam molestias iste vitae!</p><p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio voluptas dolor eum sapiente corporis, quibusdam,
provident repudiandae nisi unde quidem molestiae iusto.</p><ul><li>Lorem ipsum dolor sit amet consectetur adipisicing elit.
Magni dignissimos cumque enim?</li></ul>`,
    },
  ];

  searchText = '';
  selectedHelp: any = {};
  filteredResults: any = this.helpDictionary;

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private dialogRef: MatDialogRef<any>
  ) { }

  ngOnInit(): void {
    this.searchText = this.dialogData.selectedItem || '';
    const matches = this.helpDictionary.filter(
      h => h.title.toUpperCase() === this.searchText.toUpperCase()
    );
    this.selectedHelp = matches.length > 0 ? matches[0] : {};
  }

  onSelectHelp(id: string) {
    this.selectedHelp = this.helpDictionary.filter(h => h.id === id)[0];
  }

  filterDictionary() {
    if (this.searchText !== '') {
      const results = [];

      this.helpDictionary.forEach(h => {
        if (h.title.toUpperCase().indexOf(this.searchText.toUpperCase()) > -1) {
          results.push(h);
        }
        this.filteredResults = results;
      });
    } else {
      this.filteredResults = this.helpDictionary;
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
